import DownloadIcons from './DownloadIcons'
export default DownloadIcons